// @ts-ignore - The package doesn't have types, and we bypass the main entry to access raw data directly
import pincodeData from 'india-pincode-search/db/pincode_db.json';

// Helper to Title Case strings (MUMBAI -> Mumbai)
const toTitleCase = (str: string) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// We build this map lazily to avoid heavy processing on module load.
let cachedCitiesMap: Record<string, string[]> | null = null;

export const getIndianCitiesByState = (stateName: string): string[] => {
  if (!cachedCitiesMap) {
    const map: Record<string, Set<string>> = {};

    // pincodeData is an array of objects: { state: "MAHARASHTRA", district: "Mumbai", city: "MUMBAI", ... }
    for (let i = 0; i < pincodeData.length; i++) {
      const record = pincodeData[i];
      if (!record.state || !record.district) continue;

      const stateTitle = toTitleCase(record.state);
      const districtTitle = toTitleCase(record.district);
      
      // We use district as city options as it's cleaner and more standard for user selection
      if (!map[stateTitle]) {
        map[stateTitle] = new Set();
      }
      map[stateTitle].add(districtTitle);
    }

    // Convert Sets to sorted arrays
    cachedCitiesMap = {};
    for (const [state, citySet] of Object.entries(map)) {
      cachedCitiesMap[state] = Array.from(citySet).sort();
    }
  }

  // Fallback to uppercase/lowercase matching just in case
  const normalizedRequestedState = toTitleCase(stateName);
  return cachedCitiesMap[normalizedRequestedState] || [];
};
